export enum PetAnimations {
    IDLE = 'idle',
    IDLE_CLICK = 'idle_click',
    WALKING = 'walking',
    DIGGING = 'digging',
    IDLE_TO_WALKING = 'idleToWalking',
    WALKING_TO_IDLE = 'walkingToIdle',
    MINI_GAME_HUNGRY = 'miniGameHungry',
    MINI_GAME_FED = 'miniGameFed',
    HUNGRY = "hungry",
    FALLING_ASLEEP = "falling_asleep",
    SLEEPING = "sleeping",
    AWAKENING = "awakening",
}
